export default function initDropdown() {
  const dropdownTriggers = document.querySelectorAll(`[data-toggle=dropdown]`);

  dropdownTriggers.forEach((trigger) => {
    let dropdown = document.querySelector(
      `[aria-labelledby=${trigger.getAttribute("id")}]`
    );
    let viewWidth = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth
    );

    function documentClickListener(e) {
      if (!dropdown.contains(e.target) && e.target !== trigger) {
        closeDropdown();
      }
    }

    function updatePosition() {
      viewWidth = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth
      );
      dropdown.style.marginLeft = null;
      let rect = dropdown.getBoundingClientRect();

      if (rect.x + rect.width > viewWidth) {
        dropdown.style.marginLeft =
          -1 * (rect.x + rect.width - viewWidth) + "px";
      }
    }

    function openDropdown() {
      dropdown.classList.add("e5-dropdown-open");
      trigger.classList.add("e5-dropdown-open");
      trigger.setAttribute("aria-expanded", "true");

      updatePosition();

      setTimeout(() => {
        window.addEventListener("click", documentClickListener);
      }, 1);

      window.addEventListener("resize", updatePosition);
    }

    function closeDropdown() {
      dropdown.classList.remove("e5-dropdown-open");
      trigger.classList.remove("e5-dropdown-open");
      trigger.setAttribute("aria-expanded", "false");

      dropdown.style.marginLeft = null;

      window.removeEventListener("click", documentClickListener);
      window.removeEventListener("resize", updatePosition);
    }

    trigger.addEventListener("click", (e) => {
      e.preventDefault();

      if (dropdown.classList.contains("e5-dropdown-open")) {
        closeDropdown();
      } else {
        openDropdown();
        attachCloseButtonListener(); // Attach close button listener after dropdown opens
      }
    });

    function attachCloseButtonListener() {
      // Select the close button only after AJAX load completes
      const closeButton = dropdown.querySelector(".e5-dropdown-close");

      if (closeButton) {
        closeButton.addEventListener("click", (e) => {
          e.preventDefault();
          closeDropdown();
        });
      }
    }

    // Trigger attachCloseButtonListener each time AJAX reloads the dropdown content
    document.addEventListener("ajaxComplete", attachCloseButtonListener);
  });
}
